module.exports = __webpack_public_path__ + "static/bookCover-d72e78a0c38608e57d900b00ebad5998.jpg";